import { render, staticRenderFns } from "./tabla.vue?vue&type=template&id=71297a57&scoped=true"
import script from "./tabla.vue?vue&type=script&lang=js"
export * from "./tabla.vue?vue&type=script&lang=js"
import style0 from "./tabla.vue?vue&type=style&index=0&id=71297a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71297a57",
  null
  
)

export default component.exports